import React, {useState} from 'react';

import './TopHeader.scss';

import {Header, Nav, Navbar} from "rsuite";
import LayoutService from "../../../../services/layout.service";
import Buttons from "../../../buttons/buttons";
import BottomSheet from "../../elements/bottom_sheet/BottomSheet";

const TopHeader = (props) => {
    const [bottomSheetConfig, setBottomSheetConfig] = useState({});

    function bottomSheetHandler(config) {
        setBottomSheetConfig(config);
    }

    return (<div className="top-header">
            <Header>
                <Navbar appearance="inverse">
                    <Navbar.Brand>
                        <img src={LayoutService.getHeader().logo.original}/>
                    </Navbar.Brand>
                    <Nav>
                        <Buttons buttons={LayoutService.getHeader().buttons}
                                 bottomSheetConfig={bottomSheetConfig}
                                 bottomSheetHandler={bottomSheetHandler}/>
                    </Nav>
                </Navbar>
            </Header>

            <BottomSheet bottomSheetConfig={bottomSheetConfig}
                         bottomSheetHandler={bottomSheetHandler}/>
        </div>
    );
}

export default TopHeader;
